import { ReactNode } from 'react';

interface Children {
    children: ReactNode;
}

const SuggestShippingContainer = ({ children }: Children) => (
    <div
        className="flex justify-center items-center border rounded-8 border-bluegray-200 p-16  leading-18 text-center"
        style={{ height: '198px' }}
    >
        <div className="h-fit w-full flex flex-col justify-center items-center">{children}</div>
    </div>
);

export default SuggestShippingContainer;
